import { cardTypeEntityToDto } from "src/app/features/CardType/services/mappers/CardTypeEntityToDto";
import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { FormMutation } from "../../../../../core/service/types/FormMutation";
import type { FormQuery } from "../../../../../core/service/types/FormQuery";
import type { Dto } from "../../../../../core/types/be/Dto";
import type { CardTypeEntity } from "../../types/CardTypeEntity";
import { cardTypeDtoToEntity } from "../mappers/CardTypeDtoToEntity";

const CardTypeApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        CardTypeLoad: builder.query<CardTypeEntity, FormQuery>({
            providesTags: [ResourceName.CARD_TYPES],
            query: (queryParams) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.CARD_TYPES}/${queryParams.entityId}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return cardTypeDtoToEntity(response);
            },
        }),
        CardTypeSave: builder.mutation<CardTypeEntity, FormMutation<CardTypeEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.CARD_TYPES}`;
                const method = "POST";

                const body = cardTypeEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.CARD_TYPES],
        }),
        CardTypeUpdate: builder.mutation<CardTypeEntity, FormMutation<CardTypeEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.CARD_TYPES}/${mutation.data.id}`;
                const method = "PUT";

                const body = cardTypeEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.CARD_TYPES],
        }),
    }),
});

export const { useCardTypeLoadQuery, useCardTypeSaveMutation, useCardTypeUpdateMutation } = CardTypeApi;
